import React from 'react';
import './LoadingSpinner.css';

/**
 * LoadingSpinner Component
 * Smooth animated spinner for API calls and data loading
 *
 * Props:
 * - size: 'small' | 'medium' | 'large' (default: 'medium')
 * - message: Optional loading message to display
 * - fullScreen: If true, displays as full-screen overlay
 * - transparent: If true, background is transparent (default: false)
 */
const LoadingSpinner = ({
  size = 'medium',
  message = 'Loading...',
  fullScreen = false,
  transparent = false,
  show = true
}) => {
  if (!show) return null;

  const containerClass = `loading-spinner-container ${fullScreen ? 'full-screen' : ''} ${transparent ? 'transparent' : ''}`;

  return (
    <div className={containerClass}>
      <div className={`loading-spinner ${size}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
